export default `vec4 q = vec4(p - 1.0, 1.0);
    for(int i = 0; i < 5; i++) {
      q.xyz = abs(q.xyz + 1.0) - 1.0;
      q /= clamp(dot(q.xyz, q.xyz), 0.25, 1.0);
      q *= 1.15;
    }
    return (length(q.zy) - 1.2)/q.w;
  }`